import { render, staticRenderFns } from "./MachineDrawersHistory.vue?vue&type=template&id=48196954&"
import script from "./MachineDrawersHistory.js?vue&type=script&lang=js&"
export * from "./MachineDrawersHistory.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports